<template>
<v-container>
 <v-snackbar
  v-model="snackbar"
  :color="snackbarColor"
  :top="true"
  :right="true"
  :timeout="6000"
  >
  {{ message }}
  <v-btn
    dark
    text
    @click="snackbar = false"
  >
    CLOSE
  </v-btn>
 </v-snackbar>
 <v-layout row wrap ml-3>
    <!-- <v-flex xs2 style="padding: 3px"  >
        <v-card raised height="155px" class="card">
          <v-card-text class="text-center">
              <span class="accentd--text cardtext"> Parchment Timer </span>
              <p class="accentd--text cardtext">  {{ daysParchment }} Days {{ hoursParchment }} Hrs {{ minutesParchment }} Mins {{ secondsParchment  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>

          </v-card-text>
        </v-card>
      </v-flex>  -->
      <v-flex xs2 style="padding: 3px"  v-if="displayTimerDispatch">
        <v-card raised height="155px" class="card" v-if="displayTimerDispatch">
          <v-card-text class="text-center">
            <span class="accentd--text cardtext"> Dispatch Timer </span>
            <p class="accentd--text cardtext">  {{ daysDispatch }} Days {{ hoursDispatch }} Hrs {{ minutesDispatch }} Mins {{ secondsDispatch  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>

          </v-card-text>
        </v-card>
      </v-flex>
      <!-- <v-flex xs2 style="padding: 3px"  v-if="displayTimerCleanCoffee">
        <v-card raised height="155px" class="card" v-if="displayTimerCleanCoffee">
          <v-card-text class="text-center">
              <span class="accentd--text cardtext"> Clean Coffee Timer </span>
              <p class="accentd--text cardtext">  {{ daysCleanCoffee }} Days {{ hoursCleanCoffee }} Hrs {{ minutesCleanCoffee }} Mins {{ secondsCleanCoffee  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}  </p>

          </v-card-text>
        </v-card>
      </v-flex>   -->
      <!-- <v-flex xs2 style="padding: 3px" v-if="displayTimerCatalogue">
        <v-card raised height="155px" class="card" v-if="displayTimerCatalogue">
          <v-card-text class="text-center">
              <span class="accentd--text cardtext"> Catalogue Timer </span>
              <p class="accentd--text cardtext">  {{ daysCatalogue }} Days {{ hoursCatalogue }} Hrs {{ minutesCatalogue }} Mins {{ secondsCatalogue  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}   </p>
            </v-card-text>
        </v-card>
      </v-flex>   -->
      <!-- <v-flex xs2 style="padding: 3px" v-if="displayTimerAuction">
        <v-card raised height="155px" class="card" v-if="displayTimerAuction ">
          <v-card-text class="text-center">
              <span class="accentd--text cardtext"> Auction Timer </span>
              <p class="accentd--text cardtext">  {{ daysAuction }} Days {{ hoursAuction }} Hrs {{ minutesAuction }} Mins {{ secondsAcution  }} Seconds Remaining for saleNo {{ saleNo }} Sale Date {{ saleDate }}   </p>
            </v-card-text>
        </v-card>
      </v-flex>  -->
</v-layout>
  <v-layout row wrap mb-2  class="mt-10">
  <v-flex xs6>
    <p class="white--text tdate">  {{ todaysDate }} </p>
    <p class="white--text activity">  </p>
  </v-flex>
  <v-flex xs3>
  </v-flex>
  <v-flex xs3 class="text-lg-right">
      <v-overflow-btn
            style="background-color: white"
            color="primary"
            v-model="selectedEntity"
            :items="children"
            label="Entities"
            target="#dropdown-example"
            item-value="organisationCode"
            item-text="organisationCode"
      ></v-overflow-btn>
  </v-flex>
 </v-layout>
 <v-layout row wrap ml-3>
  <v-flex xs3>
    <v-card raised height="200" class="card">
      <v-card-text class="text-xs-center">
          <span class="cardnumber accentd--text"> {{ pendingStats.count }} </span>
          <p class="accentd--text cardtext"> Pending Loan Requests </p>
          <p class="cardnumber accentd--text">{{ formatAsCurrency(pendingStats.value, 0)}}</p>
          <router-link to="/loan/loanrequests" class="cardlink">View More</router-link>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs3 class="pl-5">
    <v-card raised height="200" class="card">
      <v-card-text class="text-xs-center">
          <span class="cardnumber accentd--text"> {{ approvedStats.count }} </span>
          <p class="accentd--text cardtext"> Approved Loan Requests </p>
          <p class="cardnumber accentd--text">{{ formatAsCurrency(approvedStats.value, 0)}}</p>
          <router-link to="/loan/approvedrequests" class="cardlink">View More</router-link>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs3  class="pl-5">
    <v-card raised height="200" class="card">
      <v-card-text class="text-xs-center">
          <span class="cardnumber accentd--text"> {{ pendingFarmerCount }} </span>
          <p class="accentd--text cardtext"> Farmer Upload Requests </p>
          <router-link to="/farmers/farmers" class="cardlink">View More</router-link>
      </v-card-text>
    </v-card>
  </v-flex>
  <v-flex xs3  class="pl-5">
    <v-card raised height="200" class="card">
      <v-card-text class="text-xs-center">
          <span class="cardnumber accentd--text"> {{ pendingLimitCount }} </span>
          <p class="accentd--text cardtext"> Cherry Upload Requests </p>
          <router-link to="/farmers/limits/files" class="cardlink">View More</router-link>
      </v-card-text>
    </v-card>
  </v-flex>
 </v-layout>
<!-- <v-layout mt-2 ml-3>
  <v-flex xs4>
     <v-card height="400">
          <v-card-title> Limit Utilization </v-card-title>
          <v-card-text>
            <pie-chart v-if="loaded" :data="pieChartData" :options="pieChartOptions"/>
          </v-card-text>
      </v-card>
  </v-flex>
</v-layout> -->

</v-container>
</template>

<script>
import axios from 'axios'
import config from '../../config'
import { mapState } from 'vuex'
// import PieChart from '../charts/piechart'

export default {
	name: 'FCSManagerDash',
	components: {
		// PieChart
	},
	data: function () {
		return {
			message: '',
			snackbar: false,
			snackbarColor: '',
			pendingStats: { count: 0, value: 0 },
			approvedStats: { count: 0, value: 0 },
			farmerCount: 0,
			selectedEntity: '',
			pendingFarmerCount: 0,
			pendingLimitCount: 0,
			loaded: false,
			pieChartData: {},
			remainingTimeParchment: 0,
			remainingTimeDispatch: 0,
			remainingTimeCleanCoffee: 0,
			remainingTimeCatalogue: 0,
			remainingTimeAuction: 0,
			targetDateParchment: '',
			targetDateDispatch: '',
			targetDateCleanCoffee: '',
			targetDateCatalogue: '',
			targetDateAuction: '',
			displayTimerParchment: true,
			displayTimerDispatch: true,
			displayTimerCleanCoffee: true,
			displayTimerCatalogue: true,
			displayTimerAuction: true,
			interval: null,
			days: 0,
			hours: 0,
			minutes: 0,
			seconds: 0,
			daysParchment: 0,
			hoursParchment: 0,
			minutesParchment: 0,
			secondsParchment: 0,
			daysDispatch: 0,
			hoursDispatch: 0,
			minutesDispatch: 0,
			secondsDispatch: 0,
			daysCleanCoffee: 0,
			hoursCleanCoffee: 0,
			minutesCleanCoffee: 0,
			secondsCleanCoffee: 0,
			daysCatalogue: 0,
			hoursCatalogue: 0,
			minutesCatalogue: 0,
			secondsCatalogue: 0,
			daysAuction: 0,
			hoursAuction: 0,
			minutesAuction: 0,
			secondsAcution: 0,
			isDashboard: false,
			saleNo: '',
			saleDate: '',
			pieChartOptions: { hoverBorderWidth: 20 }
		}
	},
	computed: {
		todaysDate: function () {
			const now = new Date()
			const options = {
				day: 'numeric',
				month: 'short',
				weekday: 'long',
				year: 'numeric'
			}
			return now.toLocaleString('en-us', options)
		},
		...mapState([
			'userInfo', 'user'
		]),
		children: function () {
			if (this.user) {
				let orgs = this.user.organisation.children
				if (orgs !== undefined) {
					orgs.unshift(this.user.organisation)
					console.log('orgs', orgs)
					orgs = orgs.filter(child => child.status.id === 1)
					return orgs
				}
			}
			return []
		}
	},
	async mounted () {
		this.startCountdown()
		await this.getUpcomingDate()
		// this.getPendingRequests()
		// this.getApprovedRequests()
		// this.getFarmerCount()
		this.selectedEntity = this.user.organisation.organisationCode
		this.selectedEntityId = this.user.organisation.id
		// this.getLimitUsageData()
	},
	watch: {
		selectedEntity: function (val) {
			this.getFarmerCount()
			this.getPendingRequests()
			this.getApprovedRequests()
			this.getPendingFarmerRequests()
			this.getPendingLimitRequests()
		}
	},
	methods: {
		// getLimitUsageData () {
		//   this.loaded = false
		//   this.pieChartData = {
		//     hoverBackgroundColor: 'red',
		//     hoverBorderWidth: 10,
		//     labels: ['Utilized', 'Remainder'],
		//     datasets: [
		//       {
		//         label: ' ',
		//         backgroundColor: ['#41B883', '#E46651'],
		//         data: [30, 70]
		//       }
		//     ]
		//   }
		//   this.loaded = true
		// },
		formatAsCurrency (value, dec) {
			dec = dec || 0
			if (value === null) {
				return 0
			}
			return 'KES ' + value.toFixed(dec).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')
		},
		getPendingRequests () {
			const url = config.serverURI + `/disbursement/fcs-manager/pendingcount/${this.selectedEntity}`
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.pendingStats = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getApprovedRequests () {
			const url = config.serverURI + `/disbursement/fcs-manager/approvedcount/${this.selectedEntity}`
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.approvedStats = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getFarmerCount () {
			const url = config.serverURI + `/upload/cherry/fcs-manager/farmer/count/${this.selectedEntity}`
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.farmerCount = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getPendingFarmerRequests () {
			const url = config.serverURI + `/upload/cherry/pending_farmer_files_count/${this.selectedEntity}`
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.pendingFarmerCount = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		getPendingLimitRequests () {
			const url = config.serverURI + `/upload/cherry/pending_limit_files_count/${this.selectedEntity}`
			axios.get(url)
				.then(response => {
					if (response.status !== 200) {
						this.error = response.statusText
						console.log('Error is ' + this.error)
						return
					}
					this.pendingLimitCount = response.data
				})
				.catch(error => {
					console.log('error', error)
				})
		},
		startCountdown () {
			this.interval = setInterval(this.updateParchmentCountdown, 1000)
			this.interval = setInterval(this.updateDispatchCountdown, 1000)
			this.interval = setInterval(this.updateCleanCoffeeCountdown, 1000)
			this.interval = setInterval(this.updateCatalogueCountdown, 1000)
			this.interval = setInterval(this.updateAuctionCountdown, 1000)
		},
		updateParchmentCountdown () {
			const now = new Date().getTime()
			this.displayTimerParchment = this.targetDateParchment !== 0

			const distanceParchment = this.targetDateParchment - now
			if (distanceParchment < 0) {
				clearInterval(this.interval)
				// this.isUploadDisabled = true;
				this.daysParchment = 0
				this.hoursParchment = 0
				this.minutesParchment = 0
				this.secondsParchment = 0
				return
			}
			this.daysParchment = Math.floor(distanceParchment / (1000 * 60 * 60 * 24))
			this.hoursParchment = Math.floor((distanceParchment % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesParchment = Math.floor((distanceParchment % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsParchment = Math.floor((distanceParchment % (1000 * 60)) / 1000)
		},
		updateDispatchCountdown () {
			const now = new Date().getTime()
			this.displayTimerDispatch = this.targetDateDispatch !== 0

			const distanceDispatch = this.targetDateDispatch - now
			if (distanceDispatch < 0) {
				this.daysDispatch = 0
				this.hoursDispatch = 0
				this.minutesDispatch = 0
				this.secondsDispatch = 0
				return
			}
			this.daysDispatch = Math.floor(distanceDispatch / (1000 * 60 * 60 * 24))
			this.hoursDispatch = Math.floor((distanceDispatch % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesDispatch = Math.floor((distanceDispatch % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsDispatch = Math.floor((distanceDispatch % (1000 * 60)) / 1000)
		},
		updateCleanCoffeeCountdown () {
			const now = new Date().getTime()
			this.displayTimerCleanCoffee = this.targetDateCleanCoffee !== 0

			const distanceCleanCoffee = this.targetDateCleanCoffee - now
			if (distanceCleanCoffee < 0) {
				this.daysCleanCoffee = 0
				this.hoursCleanCoffee = 0
				this.minutesCleanCoffee = 0
				this.secondsCleanCoffee = 0
				return
			}
			this.daysCleanCoffee = Math.floor(distanceCleanCoffee / (1000 * 60 * 60 * 24))
			this.hoursCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsCleanCoffee = Math.floor((distanceCleanCoffee % (1000 * 60)) / 1000)
		},
		updateCatalogueCountdown () {
			const now = new Date().getTime()
			this.displayTimerCatalogue = this.targetDateCatalogue !== 0

			const distanceCatalogue = this.targetDateCatalogue - now
			if (distanceCatalogue < 0) {
				this.daysCatalogue = 0
				this.hoursCatalogue = 0
				this.minutesCatalogue = 0
				this.secondsCatalogue = 0
				return
			}
			this.daysCatalogue = Math.floor(distanceCatalogue / (1000 * 60 * 60 * 24))
			this.hoursCatalogue = Math.floor((distanceCatalogue % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesCatalogue = Math.floor((distanceCatalogue % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsCatalogue = Math.floor((distanceCatalogue % (1000 * 60)) / 1000)
		},
		updateAuctionCountdown () {
			const now = new Date().getTime()
			this.displayTimerAuction = this.targetDateAuction !== 0
			console.log(this.targetDateAuction)
			const distanceAuction = this.targetDateAuction - now
			if (distanceAuction < 0) {
				this.daysAuction = 0
				this.hoursAuction = 0
				this.minutesAuction = 0
				this.secondsAcution = 0
				return
			}
			this.daysAuction = Math.floor(distanceAuction / (1000 * 60 * 60 * 24))
			this.hoursAuction = Math.floor((distanceAuction % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
			this.minutesAuction = Math.floor((distanceAuction % (1000 * 60 * 60)) / (1000 * 60))
			this.secondsAcution = Math.floor((distanceAuction % (1000 * 60)) / 1000)
		},
		async getUpcomingDate () {
			const token = localStorage.getItem('token')
			const tokenconfig = { headers: { Authorization: `Bearer ${token}` } }
			const patchUpcomingDate = config.serverURI + '/timer/upcomingdatewh/PARCHMENT'
			const dispatchUpcomingDate = config.serverURI + '/timer/upcomingdatewh/GRN'
			const cleanCoffeeUpcomingDate = config.serverURI + '/timer/upcomingdatewh/CLEAN-COFFEE'
			const catalogueUpcomingDate = config.serverURI + '/timer/upcomingdatewh/CATALOGUE'
			const auctionUpcomingDate = config.serverURI + '/timer/upcomingdatewh/AUCTION'

			const patchmentReq = axios.get(patchUpcomingDate, { tokenconfig })
			const dispatchReq = axios.get(dispatchUpcomingDate, { tokenconfig })
			const cleancoffeeReq = axios.get(cleanCoffeeUpcomingDate, { tokenconfig })
			const catalogueReq = axios.get(catalogueUpcomingDate, { tokenconfig })
			const auctionReq = axios.get(auctionUpcomingDate, { tokenconfig })

			await axios
				.all([patchmentReq, dispatchReq, cleancoffeeReq, catalogueReq, auctionReq])
				.then(
					axios.spread((...responses) => {
						const patchmentResponse = responses[0]
						const dispatchResponse = responses[1]
						const cleancoffeeResponse = responses[2]
						const catalogueResponse = responses[3]
						const auctionResponse = responses[4]

						this.targetDateParchment = patchmentResponse.data.timeInMillis
						// this.targetDateParchment = new Date().getTime() + parseInt(this.remainingTimeParchment) * 60 * 1000
						this.targetDateDispatch = dispatchResponse.data.timeInMillis
						// this.targetDateDispatch = new Date().getTime() + parseInt(this.remainingTimeDispatch) * 60 * 1000

						this.targetDateCleanCoffee = cleancoffeeResponse.data.timeInMillis
						// this.targetDateCleanCoffee  = new Date().getTime() + parseInt(this.remainingTimeCleanCoffee) * 60 * 1000

						this.targetDateCatalogue = catalogueResponse.data.timeInMillis
						// this.targetDateCatalogue = new Date().getTime() + parseInt(this.remainingTimeCatalogue) * 60 * 1000

						this.targetDateAuction = auctionResponse.data.timeInMillis
						this.saleNo = dispatchResponse.data.saleNo
						this.saleDate = dispatchResponse.data.saleDate
						// this.targetDateAuction = new Date().getTime() + parseInt(this.remainingTimeAuction) * 60 * 1000

						console.log('patchment Response :' + JSON.stringify(patchmentResponse.data))
						console.log('dispatch Response :' + JSON.stringify(dispatchResponse.data))
						console.log('clean coffee Response :' + JSON.stringify(cleancoffeeResponse.data))
						// if (fileType === 'PARCHMENT') {
						// 	this.remainingTimeParchment = response.data
						// 	this.targetDateParchment = new Date().getTime() + parseInt(this.remainingTimeParchment) * 60 * 1000
						// } else if (fileType === 'DISPATCH') {
						// 	this.remainingTimeDispatch = response.data
						// 	this.targetDateDispatch = new Date().getTime() + parseInt(this.remainingTimeDispatch) * 60 * 1000
						// } else if (fileType === 'CLEANCOFFEE') {
						// 	this.remainingTimeCleanCoffee = response.data
						// 	this.targetDateCleanCoffee  = new Date().getTime() + parseInt(this.remainingTimeCleanCoffee) * 60 * 1000
						// }

						// this.targetDate = new Date().getTime() + parseInt(this.remainingTime) * 24 * 60 * 60 * 1000
					})
				)
				.catch((errors) => {
					console.log(errors)
				})
		}
	}
}
</script>
<style>
.tdate {
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 5px;
}
.card {
  background-image: linear-gradient(233deg, #FFFFFF, #FFFFFF);
}
.cardnumber {
  font-size: 30px;
  font-weight: 700;
}
.cardlink {
  color: #7BC243;
  font-style: Open Sans;
}
</style>
